import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import MainLayout from './components/Layout/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ClientList from './pages/clients/ClientList';
import ClientForm from './pages/clients/ClientForm';
import ClientDetail from './pages/clients/ClientDetail';
import SavingsAccounts from './pages/accounts/SavingsAccounts';
import LoanList from './pages/loans/LoanList';
import LoanForm from './pages/loans/LoanForm';
import Repayments from './pages/repayments/Repayments';
import Reports from './pages/reports/Reports';
import Users from './pages/users/Users';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
///////////////////////////////////////////////
import AgencyList from './pages/agencies/AgencyList';
import AgencyForm from './pages/agencies/AgencyForm';
import AgencyDetail from './pages/agencies/AgencyDetail';
import TenantDashboard from './pages/tenants/TenantDashboard';
import TenantSettings from './pages/tenants/TenantSettings';
//////////////////USER ROUTES/////////////////////
import UserList from './pages/users/UserList';
import UserForm from './pages/users/UserForm';
import UserDetail from './pages/users/UserDetail';
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('access_token');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/* Clients Routes */}
            <Route path="clients" element={<ClientList />} />
            <Route path="clients/new" element={<ClientForm />} />
            <Route path="clients/edit/:id" element={<ClientForm />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            
            {/* Accounts Routes */}
            <Route path="accounts" element={<SavingsAccounts />} />
            <Route path="accounts/new" element={<ClientForm />} />
            <Route path="accounts/:id" element={<ClientDetail />} />
            
            {/* Loans Routes */}
            <Route path="loans" element={<LoanList />} />
            <Route path="loans/new" element={<LoanForm />} />
            <Route path="loans/:id" element={<ClientDetail />} />
            
            {/* Repayments */}
            <Route path="repayments" element={<Repayments />} />
            
            {/* Reports */}
            <Route path="reports" element={<Reports />} />
            
            {/* Users 
            <Route path="users" element={<Users />} />*/}
            <Route path="users" element={<UserList />} />
            <Route path="users/new" element={<UserForm />} />
            <Route path="users/edit/:id" element={<UserForm />} />
            <Route path="users/:id" element={<UserDetail />} />
            {/* Settings */}
            <Route path="settings" element={<Settings />} />
            <Route path="profile" element={<Profile />} />
            {/* ///////////////////////////////////////////////*/}
            <Route path="agencies" element={<AgencyList />} />
            <Route path="agencies/new" element={<AgencyForm />} />
            <Route path="agencies/edit/:id" element={<AgencyForm />} />
            <Route path="agencies/:id" element={<AgencyDetail />} />
            <Route path="tenant/dashboard" element={<TenantDashboard />} />
            <Route path="tenant/settings" element={<TenantSettings />} />
          </Route>
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;